import { render, staticRenderFns } from "./deviceDistribute.vue?vue&type=template&id=23955527&scoped=true"
import script from "./deviceDistribute.vue?vue&type=script&lang=js"
export * from "./deviceDistribute.vue?vue&type=script&lang=js"
import style0 from "./deviceDistribute.vue?vue&type=style&index=0&id=23955527&prod&lang=scss&scoped=true"
import style1 from "./deviceDistribute.vue?vue&type=style&index=1&id=23955527&prod&lang=scss&scoped=true"
import style2 from "./deviceDistribute.vue?vue&type=style&index=2&id=23955527&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23955527",
  null
  
)

export default component.exports